import Button from '@/components/common/Button';
import Card from '@/components/common/Card';
import useSettings from '@/hooks/useSettings';
import { Payment } from '@/types';
import { formatPrice } from '@/utils/format';

interface PixAutoSuccessPaymentProps {
  payment: Payment;
  onContinue?: () => void;
}

const PixAutoSuccessPayment = ({ payment, onContinue }: PixAutoSuccessPaymentProps) => {
  const settings = useSettings();


  return (
    <Card
      style={{
        backgroundColor: settings.form?.background.color
      }}
    >
      <div
        style={{
          backgroundColor: settings.form?.background.color
        }}
        className="p-6 md:mx-auto"
      >
        <svg viewBox="0 0 24 24" className="text-green-600 w-16 h-16 mx-auto my-6">
          <path
            fill="currentColor"
            d="M12,0A12,12,0,1,0,24,12,12.014,12.014,0,0,0,12,0Zm6.927,8.2-6.845,9.289a1.011,1.011,0,0,1-1.43.188L5.764,13.769a1,1,0,1,1,1.25-1.562l4.076,3.261,6.227-8.451A1,1,0,1,1,18.927,8.2Z"
          ></path>
        </svg>

        <div className="flex w-full flex-col items-center">
          <h1 className="text-center text-2xl font-bold text-green-600 mb-4">
            PIX Automático configurado com sucesso!
          </h1>

          <p className="text-center text-gray-600 mb-6">
            Seu pagamento foi aprovado e o PIX Automático foi configurado.
            As próximas cobranças serão feitas automaticamente.
          </p>

          <div className="bg-gray-50 rounded-lg p-4 w-full mb-6">
            <h3 className="text-lg font-semibold text-gray-900 mb-3 text-center">
              Detalhes do Pagamento
            </h3>
            <div className="space-y-2">
              <div className="flex justify-between items-center">
                <span className="text-gray-600 text-sm">Método de Pagamento:</span>
                <span className="text-gray-900 font-medium text-sm">PIX Automático</span>
              </div>

              <div className="flex justify-between items-center">
                <span className="text-gray-600 text-sm">Valor:</span>
                <span className="text-gray-900 font-medium text-sm">
                  {formatPrice(payment.amount)}
                </span>
              </div>

              <div className="flex justify-between items-center">
                <span className="text-gray-600 text-sm">Status:</span>
                <span className="text-green-600 font-medium text-sm">Aprovado</span>
              </div>

              <div className="flex justify-between items-center">
                <span className="text-gray-600 text-sm">ID da Transação:</span>
                <span className="text-gray-900 font-mono text-xs">
                  {payment.id}
                </span>
              </div>
            </div>
          </div>

          <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 w-full mb-6">
            <h4 className="text-md font-semibold text-blue-900 mb-2">
              PIX Automático Ativo
            </h4>
            <p className="text-blue-800 text-sm">
              A partir de agora, suas cobranças serão processadas automaticamente via PIX.
              Você não precisará fazer nada - o sistema cuidará de tudo para você!
            </p>
          </div>

          {onContinue && (
            <div className="w-full max-w-md">
              <Button
                style={{
                  backgroundColor: settings.payButton.color,
                  color: settings.payButton.text.color
                }}
                onClick={onContinue}
                className="w-full hover:opacity-90 transition-opacity"
              >
                ACESSAR MEU PRODUTO
              </Button>
            </div>
          )}

          <span
            style={{ color: settings.text.color.secondary }}
            className="mt-6 text-gray-500 text-sm text-center"
          >
            Também enviamos uma confirmação para o seu e-mail.
          </span>
        </div>
      </div>
    </Card>
  );
};

export default PixAutoSuccessPayment;
